import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_user } from '@/hooks/store/use_slices';
import { service_translate_generations } from '@/services/translate/SERVICE__translate_generations';
import { service_translate_searches } from '@/services/translate/service_translate_searches';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { useState } from 'react';

export function WatcherLanguageChangeNotifier() {
  const { user_settings } = use_slice_user(['user_settings']);

  const [language, set_language] = useState(user_settings.regional_language);

  /*
   * EFFECTS
   */

  //set language from i18n
  use_effect(() => {
    if (language == user_settings.regional_language) return;
    if (!CONSTANTS__shared.SUPPORTED_LANGUAGES.includes(language)) return;

    set_language(language);

    service_translate_generations.on_language_changed();
    service_translate_searches.on_language_changed();
  }, [user_settings.regional_language]);

  /*
   * METHODS
   */

  return <></>;
}
